export class Invitation {
    accepted: boolean;
    acceptedDate: string;
    businessAccountId: string;
    businessAccountName: string;
    businessAccountSurname: string;
    id: string;
}